module.exports = __webpack_public_path__ + "media/images/riders/FLORENT_PAYET-09b6c3ad08929d47d2fae0239c31218d.png";